
export const OTHERS_ORGANISATION_LABEL = "Others";
 
const normalize = (value) => String(value ?? "").trim().toLowerCase();
 
/**

* Pull the canonical organisation labels out of the apiCache master.

* @param {Record<string, any> | null | undefined} apiCache

* @returns {string[]}

*/

export function getOrganisationList(apiCache) {
  const data = apiCache?.organizationdetailsmasters?.data;
  if (!Array.isArray(data)) return [];
  const labels = [];
  for (const item of data) {
    const label = item?.organizationName;
    if (typeof label === "string" && label.trim()) {
      labels.push(label.trim());
    }
  }
  return labels;
}
 
/**

* @param {string | null | undefined} orgName

* @param {Record<string, any> | null | undefined} apiCache

* @returns {boolean} true when orgName exactly matches a listed organisation

*   (case-insensitive, trimmed). "Others" is intentionally NOT considered listed.

*/

export function isOrganisationListed(orgName, apiCache) {
  const needle = normalize(orgName);
  if (!needle) return false;
  if (needle === normalize(OTHERS_ORGANISATION_LABEL)) return false;
  const list = getOrganisationList(apiCache);
  for (const label of list) {
    if (normalize(label) === needle) return true;
  }
  return false;
}
 